module.exports = __webpack_public_path__ + "static/media/austria_huong.32c73c8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/austria_huong.jpg
// module id = 437
// module chunks = 0